import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#f1f5f9] py-16 px-4" data-id="element-251" data-mp="2lstjzhrrqcfl">
      <div className="max-w-5xl mx-auto" data-id="element-252" data-mp="2lq8hcqjnbsgs">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-8 text-center" data-id="element-253" data-mp="30hpnd1ivr19v">
          El problema real
        </h2>

        <div className="bg-white rounded-lg p-6 md:p-8 shadow-md mb-8" data-id="element-254" data-mp="2vppn17ywe6cr">
          <p className="text-lg text-[#1a2332] leading-relaxed mb-6" data-id="element-255" data-mp="39h4gk8qflpy2">
            Si tienes más de 30 años, trabajas todo el día y llegas cansado a tu
            hogar, eres la víctima perfecta del retail. Pagas precios inflados
            por conveniencia: envases pequeños que cuestan el doble, comida
            preparada llena de sodio y vegetales que terminan pudriéndose en el
            cajón del refrigerador porque "eran mucha cantidad para uno".
          </p>

          <div className="bg-red-50 border-l-4 border-[#ef4444] p-6 rounded-r-lg" data-id="element-256" data-mp="1k2xzn1woii6w">
            <div className="flex items-start gap-4" data-id="element-257" data-mp="1k5an1ul7hkrc">
              <AlertTriangleIcon className="w-8 h-8 text-[#ef4444] flex-shrink-0 mt-1" data-id="element-258" data-mp="je6g10cwmm9g" />
              <div data-id="element-259" data-mp="obetwor0s44w">
                <p className="text-lg text-[#1a2332] leading-relaxed" data-id="element-260" data-mp="ocq0ewbunpzp">
                  Cada vez que compras por impulso o sin un sistema, estás
                  regalando entre{' '}
                  <span className="font-bold text-[#ef4444] text-xl" data-id="element-261" data-mp="x5js5t8hghug">
                    $80.000 y $120.000 pesos mensuales
                  </span>{' '}
                  que podrías usar para viajar, ahorrar o simplemente vivir con
                  la tranquilidad de que el mes no te queda grande.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}